import { Flex, Row } from "antd";
import { HOME_DASHBOARD_CARDS } from "../../utils/constants";
import HomeDashboardCard from "./HomeDashboardCard";
import HomeDashboardDiv from "./HomeDashboardDiv";
import PeriodSelector from "./PeriodSelector";

const formatCurrency = (value) => {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export default function HomeDashboard({
  selectedPeriod,
  setSelectedPeriod,
  revenueKPIsData,
  isLoadingRevenueKPIsData,
  permanenceData,
  isLoadingPermanenceData,
  startDate,
  endDate,
}) {
  const getCardValue = (card) => {
    if (card.key === "receita_hora") {
      return revenueKPIsData &&
        permanenceData &&
        permanenceData.kpi_data.total_occupied_time > 0
        ? revenueKPIsData.faturamento_total /
            permanenceData.kpi_data.total_occupied_time /
            60
        : 0;
    }
    if (card.key === "conversao") {
      return Math.round(revenueKPIsData?.[card.key] || 0);
    }
    return revenueKPIsData?.[card.key] || 0;
  };

  const getTagValue = (card) => {
    if (card.tagValue === "variacao_receita_hora") {
      return revenueKPIsData && permanenceData ? RevenuePerHourVariation() : 0;
    } else {
      return revenueKPIsData?.[card.tagValue].toFixed(2) || 0;
    }
  };

  const RevenuePerHourVariation = () => {
    if (
      revenueKPIsData.faturamento_total_doubled === 0 ||
      permanenceData.kpi_data_doubled.total_occupied_time === 0
    )
      return 0;
    if (!isLoadingRevenueKPIsData && !isLoadingPermanenceData) {
      const normal =
        revenueKPIsData.faturamento_total /
        permanenceData.kpi_data.total_occupied_time /
        60;
      const doubled =
        revenueKPIsData.faturamento_total_doubled /
        permanenceData.kpi_data_doubled.total_occupied_time /
        60;
      const variation = (((normal - doubled) / doubled) * 100).toFixed(2);
      return variation;
    }
  };

  return (
    <Flex vertical flex={1} gap={20} style={{ padding: "0 2rem" }}>
      <PeriodSelector
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        startDate={startDate}
        endDate={endDate}
      />

      <Row gutter={[32, 24]} justify="space-between" align="middle">
        {HOME_DASHBOARD_CARDS.map((card, index) => (
          <HomeDashboardCard
            key={index}
            {...card}
            value={getCardValue(card)}
            tagValue={getTagValue(card)}
            cardKey={card.key}
            formatter={
              card.formatter === "currency" ? formatCurrency : undefined
            }
            isLoadingRevenueKPIsData={isLoadingRevenueKPIsData}
            isLoadingPermanenceData={isLoadingPermanenceData}
            revenueKPIsData={revenueKPIsData}
            permanenceData={permanenceData}
          />
        ))}
      </Row>

      <Row xs={24} sm={24} md={24} lg={12} xl={12} style={{ width: "100%" }}>
        <HomeDashboardDiv
          title_high={"Zonas em alta"}
          title_low={"Zonas em baixa"}
          type="zones"
          startDate={startDate}
          endDate={endDate}
        />

        <HomeDashboardDiv
          title_high="Coleções em alta"
          title_low="Coleções em baixa"
          type="collections"
          startDate={startDate}
          endDate={endDate}
        />
      </Row>
    </Flex>
  );
}
